import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, totalClients, filteredCount }) => {
  const handleSearchChange = (e) => {
    onFilterChange?.({ ...filters, searchTerm: e?.target?.value });
  };

  const handleFilterChange = (key, value) => {
    onFilterChange?.({ ...filters, [key]: value });
  };

  const clearFilters = () => {
    onFilterChange?.({
      setupStatus: 'all',
      complianceScore: 'all',
      billingStatus: 'all',
      region: 'all',
      searchTerm: ''
    });
  };

  const hasActiveFilters = 
    filters?.setupStatus !== 'all' ||
    filters?.complianceScore !== 'all' ||
    filters?.billingStatus !== 'all' ||
    filters?.region !== 'all' ||
    filters?.searchTerm !== '';

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-foreground">Advanced Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={clearFilters}
          >
            <Icon name="X" size={14} className="mr-1" />
            Clear Filters
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Search */}
        <div className="lg:col-span-2">
          <label className="block text-sm font-medium text-foreground mb-2">Search Organizations</label>
          <div className="relative">
            <Icon name="Search" size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Organization name, email..."
              value={filters?.searchTerm}
              onChange={handleSearchChange}
              className="w-full pl-10 pr-4 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
            />
          </div>
        </div>

        {/* Setup Status */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Setup Progress</label>
          <select
            value={filters?.setupStatus}
            onChange={(e) => handleFilterChange('setupStatus', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Status</option>
            <option value="complete">Complete (100%)</option>
            <option value="partial">Partial (50-99%)</option>
            <option value="incomplete">Incomplete (&lt;50%)</option>
          </select>
        </div>

        {/* Compliance Score */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Compliance Score</label>
          <select
            value={filters?.complianceScore}
            onChange={(e) => handleFilterChange('complianceScore', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Scores</option>
            <option value="excellent">90-100% (Excellent)</option>
            <option value="good">70-89% (Good)</option>
            <option value="warning">&lt;70% (Warning)</option>
          </select>
        </div>

        {/* Billing Status */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Billing Health</label>
          <select
            value={filters?.billingStatus}
            onChange={(e) => handleFilterChange('billingStatus', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Status</option>
            <option value="current">Current</option>
            <option value="overdue">Overdue</option>
            <option value="suspended">Suspended</option>
          </select>
        </div>
      </div>

      {/* Region Filter (Second Row) */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">Geographic Region</label>
          <select
            value={filters?.region}
            onChange={(e) => handleFilterChange('region', e?.target?.value)}
            className="w-full px-3 py-2 border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <option value="all">All Regions</option>
            <option value="port_moresby">Port Moresby</option>
            <option value="lae">Lae</option>
            <option value="mount_hagen">Mount Hagen</option>
            <option value="madang">Madang</option>
            <option value="wewak">Wewak</option>
            <option value="goroka">Goroka</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Showing <span className="font-medium text-foreground">{filteredCount}</span> of{' '}
          <span className="font-medium text-foreground">{totalClients}</span> client organizations
        </p>
      </div>
    </div>
  );
};

export default FilterPanel;